export { default } from './BensServicosPJ';
